<template>
  <v-col class="ma-0 pa-0">
    <!-- <v-btn class="btn__add" @click="addEmployee" dense> {{ $tc('editRegistrations.add') }} <v-icon small class="ml-1"
        color="white" dark>
        fa-plus </v-icon>
    </v-btn> -->
    <v-card max-width="700px" class="add__card ma-0 pa-0">
      <v-card-title class="title__ ma-0 pa-0 py-4">
        Agregar Empleado</v-card-title
      >
      <v-form ref="form" v-model="valid">
        <v-alert
          dense
          v-if="errorDate"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mr-1 ml-1"
        >
          {{ alertValidate }}</v-alert
        >
        <!-- photo user -->
        <div class="avatar-container pa-0 ma-0 mb-4">
          <div class="avatar">
            <div class="avatar-container">
              <div>
                <v-avatar @click="openFileInput" color="#d9d9d9" size="100">
                  <v-img
                    :src="data.photo || require('@/assets/avatar.png')"
                    style="max-width: 100%; max-height: 100%"
                  />
                </v-avatar>
                <v-icon @click="openFileInput" size="30" class="edit-icon">
                  mdi-pencil-outline
                </v-icon>
              </div>
            </div>
          </div>
          <input
            ref="fileInput"
            type="file"
            style="display: none"
            accept=".png, .jpg, .jpeg, .ico, .svg"
            @change="updatePhoto"
          />
        </div>
        <!-- Nombre y Apellido -->
        <v-row>
          <v-col class="mx-4">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="data.name"
                  required
                  :rules="rules"
                  :label="$tc('gestionEmpleados.name')"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  required
                  :rules="rules"
                  v-model="data.lastName"
                  :label="$tc('gestionEmpleados.lastName')"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row class="mt-n5">
              <v-col cols="12" sm="8" md="8" class="d-flex d-inline-flex">
                <v-select
                  :label="$tc('gestionEmpleados.typeDoc')"
                  v-model="data.typeDoc"
                  :items="doc"
                  required
                  :rules="rules"
                  style="max-width: 170px"
                  class="mr-5"
                  outlined
                  dense
                />
                <v-text-field
                  v-model="data.doc"
                  :label="$tc('gestionEmpleados.numDoc')"
                  type="number"
                  required
                  :rules="numDocRules"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  :label="$tc('gestionEmpleados.file')"
                  v-model="data.file"
                  required
                  :rules="rules"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row class="mt-n5">
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="dateHigh"
                  v-model="dateHigh"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="on"
                      :label="$tc('gestionEmpleados.high')"
                      required
                      :rules="rules"
                      v-model="formatHighDay"
                      outlined
                      dense
                    />
                  </template>
                  <v-date-picker
                    @input="dateHigh = false"
                    v-model="changeDateHigh"
                    locale="es-es"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="dateDown"
                  v-model="dateDown"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="on"
                      :label="$tc('gestionEmpleados.down')"
                      v-model="formatDownDay"
                      outlined
                      dense
                    />
                  </template>
                  <v-date-picker
                    @input="dateDown = false"
                    v-model="changeDateDown"
                    locale="es-es"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="mt-n5">
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  outlined
                  dense
                  :label="$tc('changeGroup.group')"
                  :items="getGroup"
                  item-value="groupId"
                  item-text="name"
                  v-model="group"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  outlined
                  dense
                  :label="$tc('changeSchedule.schedule')"
                  :items="getSchedules"
                  item-value="scheduleId"
                  item-text="name"
                  v-model="schedule"
                />
              </v-col>
            </v-row>
            <v-row class="mt-n5">
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  :items="getModels"
                  item-value="liqmodelId"
                  item-text="name"
                  outlined
                  dense
                  :label="$tc('changeSettlementModel.model')"
                  v-model="model"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  outlined
                  dense
                  :items="getCards"
                  item-value="cardId"
                  item-text="card"
                  :label="$tc('assignCards.card')"
                  v-model="card"
                />
              </v-col>
              <v-col class="mt-n5" cols="12" sm="12" md="12">
                <v-select
                  outlined
                  dense
                  :items="getWatches"
                  item-value="relojId"
                  item-text="nombre"
                  :label="$tc('assignWatches.title')"
                  v-model="watch"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
      <div class="d-flex justify-space-between mx-4 mb-4">
        <v-btn class="bt-exit" @click="cancel"
          >{{ $tc("editRegistrations.cancel") }}
        </v-btn>
        <v-btn class="bt-acept" @click="addValidate">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-card>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-col>
</template>

<script>
import moment from "moment";
import Snackbar from "../../../Complement/Snackbar.vue";
export default {
  components: {
    Snackbar,
  },

  data() {
    return {
      valid: true,
      textAlert: "",
      alert: false,
      alertValidate: "",
      doc: ["DNI", "CUIL"],
      error: false,
      errorDate: false,
      color: "",
      dateHigh: false,
      dateDown: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      data: {
        name: "",
        lastName: "",
        typeDoc: null,
        doc: null,
        file: null,
        high: "",
        down: null,
        photo: null,
      },
      model: null,
      card: null,
      watch: null,
      group: null,
      schedule: null,
    };
  },
  mounted() {
    this.$store.dispatch("assignWatches/getWatches");
  },
  computed: {
    getGroup() {
      return this.$store.state.changeGroup.group.item;
    },
    getSchedules() {
      return this.$store.state.changeSchedule.schedule;
    },
    getCards() {
      return this.$store.state.assignCards.cardAssign;
    },
    getWatches() {
      return this.$store.state.assignWatches.watch;
    },
    getModels() {
      return this.$store.state.gestionTiempos.models;
    },
    changeDateHigh: {
      get: function () {
        return this.$store.state.employees.addHigh;
      },
      set: function (newDate) {
        if (newDate > this.$store.state.employees.addDown) {
          this.setAddDown(newDate);
        }
        this.setAddHigh(newDate);
      },
    },
    changeDateDown: {
      get: function () {
        return this.$store.state.employees.addDown;
      },
      set: function (date) {
        if (date < this.$store.state.employees.addHigh) {
          this.setAddHigh(date);
        }
        this.setAddDown(date);
      },
    },
    numDocRules() {
      return [
        (value) => {
          if (this.data.typeDoc === "DNI") {
            if (!value || value.length !== 8) {
              return this.$tc("gestionEmpleados.rulesDni");
            }
          } else {
            if (!value || value.length !== 11) {
              return this.$tc("gestionEmpleados.rulesCuil");
            }
          }
          return true;
        },
        (v) => !!v || this.$tc("editRegistrations.requerid"),
      ];
    },
    formatHighDay: {
      get() {
        return moment(this.changeDateHigh).format("DD-MM-YYYY");
      },
      set(newValue) {
        return moment(newValue).format("DD-MM-YYYY");
      },
    },

    formatDownDay: {
      get() {
        let date = moment(this.changeDateDown).format("DD-MM-YYYY");
        return this.changeDateDown === null ? this.changeDateDown : date;
      },
      set(newValue) {
        return moment(newValue).format("DD-MM-YYYY");
      },
    },
  },
  methods: {
    openFileInput() {
      this.$refs.fileInput.click();
    },
    updatePhoto(event) {
      const file = event.target.files[0];

      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const maxWidth = 200;
            const maxHeight = 200;
            let width = img.width;
            let height = img.height;

            // Redimensionar manteniendo la relación de aspecto
            if (width > height) {
              if (width > maxWidth) {
                height = Math.round((height * maxWidth) / width);
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width = Math.round((width * maxHeight) / height);
                height = maxHeight;
              }
            }

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            const compressedDataUrl = canvas.toDataURL("image/jpeg", 0.5);

            this.data.photo = compressedDataUrl;
          };
          img.src = e.target.result;
        };

        reader.readAsDataURL(file);
      } else {
        alert("Por favor, selecciona un archivo de imagen válido.");
      }
    },

    addValidate() {
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.data.high > this.data.down) {
          this.errorDate = true;
          this.alertValidate = this.$tc("gestionEmpleados.dateHigh");
          setTimeout(() => {
            this.errorDate = false;
          }, 2500);
        } else {
          this.saveEmployed();
        }
      } else {
        this.errorDate = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.errorDate = false;
        }, 2500);
      }
    },
    saveEmployed() {
      let payload = this.data;
      payload.down = this.changeDateDown;
      payload.high = this.changeDateHigh;

      if (this.model !== null) {
        payload = {
          ...payload,
          liqModeloId: this.model,
        };
      }
      if (this.card !== null) {
        payload = {
          ...payload,
          tarjetaId: this.card,
        };
      }
      if (this.watch !== null) {
        payload = {
          ...payload,
          relojId: this.watch,
        };
      }
      if (this.group !== null)
        payload = {
          ...payload,
          grupoId: this.group,
        };
      if (this.schedule !== null) {
        payload = {
          ...payload,
          horarioId: this.schedule,
        };
      }

      this.$store.commit("employees/setNewEmployed", payload);
      this.$store
        .dispatch("employees/newEmployed")
        .then(() => {
          this.alertDispatch("Se creo correctamente", "primary", true);
          setTimeout(() => {
            this.cancel();
          }, 3000);
        })
        .catch((e) => {
          this.alertDispatch(e.response.data.error.message, "error", true);
        });
    },
    alertDispatch(text, color, alert) {
      this.alert = alert;
      this.textAlert = text;
      this.color = color;
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    async cancel() {
      this.alert = false;
      this.showAdd = false;
      this.error = false;
      this.$refs.form.resetValidation();
      const day = moment().format("YYYY-MM-DD");
      this.$store.commit("employees/setAddDown", null);
      this.$store.commit("employees/setAddHigh", day);
      await this.$store.commit("employees/setShowAdd", false);
      this.data = {
        name: "",
        lastName: "",
        typeDoc: null,
        doc: null,
        file: null,
        high: "",
        down: null,
        photo: null,
      };
      this.model = null;
      this.card = null;
      this.group = null;
      this.schedule = null;
      this.watch = null;
    },
    setAddHigh(date) {
      this.$store.commit("employees/setAddHigh", date);
    },
    setAddDown(date) {
      this.$store.commit("employees/setAddDown", date);
    },
  },
};
</script>

<style scoped>
.btn__add {
  background-color: #39537a !important;
  color: white !important;
  margin-left: 10px !important;
}
.input__ {
  max-width: 260px !important;
}
.input__whitMargin {
  max-width: 260px !important;
  margin-right: 5px !important;
}
.contein__inputs {
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  max-width: 460px !important;
}
.contein__types {
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  max-width: 660px !important;
}
.container {
  display: flex !important;
  flex-direction: column !important;
}
.title__ {
  display: flex;
  justify-content: center;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.input__3 {
  max-width: 175px !important;
  margin-left: 2px;
}
.dialogShow {
  max-width: 700px !important;
}
.add__card {
  overflow-x: hidden !important;
  scrollbar-width: unset !important;
}
.avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-container .v-avatar:hover {
  filter: blur(3px);
  transition: filter ease-out 0.2s;
  cursor: pointer;
}
.avatar {
  position: relative;
  display: inline-block;
}
.edit-icon {
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  font-size: 30px !important;
  color: #13bbf9 !important;
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
}
.avatar:hover .edit-icon {
  opacity: 1;
}
</style>
